var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-57b811ec\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HeaderFilzfelt.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/pages/wrappers/HeaderFilzfelt.vue
// module id = 559
// module chunks = 1